module.exports = __webpack_public_path__ + "img/medicina.f8358906.svg";